import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  CreateDoRequestActionOutput,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PARTICIPANT_MARK_COMPLETE = 'REQUEST_PARTICIPANT_MARK_COMPLETE'
export const doREQUEST_PARTICIPANT_MARK_COMPLETE = createDoRequestAction<RequestParticipantMarkCompletePayload>(
  REQUEST_PARTICIPANT_MARK_COMPLETE,
)

export const requestParticipantMarkCompleteActionCreators = {
  doREQUEST_PARTICIPANT_MARK_COMPLETE,
}

export type RequestParticipantMarkCompletePayload = {
  participantId: string
  force: boolean
}

export function* requestParticipantMarkComplete({
  payload,
  setRequestResult,
}: CreateDoRequestActionOutput<RequestParticipantMarkCompletePayload>): SagaIterator {
  debug('saga*requestParticipantMarkComplete')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        participantId: v.string().uuid().exist(),
        force: v.boolean().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_MARK_COMPLETE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {participantId, force} = payload

  const accessToken = yield call(getToken)
  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/mark-participant-complete`,
    accessToken,
    data: {
      participantId,
      force,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_MARK_COMPLETE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/mark-participant-complete',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PARTICIPANT_MARK_COMPLETE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* participantMarkCompleteSaga() {
  yield takeEvery(REQUEST_PARTICIPANT_MARK_COMPLETE, requestParticipantMarkComplete)
}
